import React from "react";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

export function LegalLayout({ doc }) {
  return (
    <div className="min-h-screen bg-brand-bg flex flex-col">
      <SiteHeader />
      <main className="flex-1">
        <div className="bg-brand-green text-white">
          <div className="max-w-3xl mx-auto px-5 md:px-8 py-14">
            <div className="text-xs tracking-widest font-semibold text-brand-gold uppercase mb-2">{doc.kicker}</div>
            <h1 className="font-serif text-4xl md:text-5xl">{doc.title}</h1>
            {doc.subtitle && <p className="text-white/70 mt-3 max-w-xl">{doc.subtitle}</p>}
            {doc.updated && <p className="text-white/50 text-sm mt-4">{doc.updated}</p>}
          </div>
        </div>
        <article className="max-w-3xl mx-auto px-5 md:px-8 py-12">
          {doc.intro?.map((p, i) => (
            <p key={`i-${i}`} className="text-brand-ink leading-relaxed mb-4">{p}</p>
          ))}
          {doc.sections.map((s, i) => (
            <section key={s.h} className="mt-9" data-testid={`legal-section-${i}`}>
              <h2 className="font-serif text-2xl text-brand-green mb-3">{s.h}</h2>
              {s.p?.map((p, j) => <p key={j} className="text-brand-ink leading-relaxed mb-3">{p}</p>)}
              {s.list && (
                <ul className="list-disc pl-5 space-y-1.5 text-brand-ink marker:text-brand-gold mb-3">
                  {s.list.map((li, k) => <li key={k} className="leading-relaxed">{li}</li>)}
                </ul>
              )}
            </section>
          ))}
          <div className="mt-12 pt-6 border-t border-brand-line text-sm text-brand-muted">
            <p className="font-semibold text-brand-ink">Rehoboth Wealth Management Ltd</p>
            <p>Acorn Business Centre, Unit C, Aldow Enterprise Park, Manchester, M12 6AE</p>
            <p>Tel: 0161 470 6509 · Email: clientsupport@rehowealth.co.uk</p>
            <p className="mt-1">Registered in England and Wales · Company No. 17199717 · Authorised and regulated by the Financial Conduct Authority.</p>
          </div>
        </article>
      </main>
      <SiteFooter />
    </div>
  );
}
